namespace _Ext {
    export interface AuditLogViewerRequest extends Serenity.ServiceRequest {
        FormKey?: string;
        EntityId?: number;
        TableName?: string;
    }
}
